<template>
  <div>
    <div style="display: flex;justify-content: space-between;padding-bottom: 10px;">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="dialogVisible = true ,radioCheck=false">添加广告</el-button>
    </div>
    <div style="margin-top: 20px;">
      <el-table
          v-loading="loading"
          :data="advertisingList"
          border
          style="width: 100%">
        <!--        <el-table-column-->
        <!--            fixed-->
        <!--            type="selection"-->
        <!--            width="40">-->
        <!--        </el-table-column>-->
        <el-table-column
            prop="title"
            label="标题" width="230">
        </el-table-column>
        <el-table-column
            label="封面" width="230">
          <template slot-scope="scope">
            <el-image
                style="width: 200px; height: 60px"
                :src="serverUrl+scope.row.cover"
                :fit="fit"></el-image>
          </template>
        </el-table-column>
        <el-table-column
            label="曝光量" width="120">
          <template slot-scope="scope">
<!--            <el-slider v-model="scope.row.odds" :step="5"-->
<!--                       show-stops @change="enabledChange(scope.row)"></el-slider>-->
            <el-rate v-model="scope.row.odds" :max="3" disabled></el-rate>
          </template>
        </el-table-column>
        <el-table-column
            prop="type"
            label="类别"
            width="60">
        </el-table-column>
        <el-table-column
            label="形式" width="120">
          <template slot-scope="scope">
           <div v-if="scope.row.toWeb===1">站外链接</div>
            <div v-if="scope.row.toWeb===0">站内链接</div>
          </template>
        </el-table-column>
        <el-table-column
            prop="date"
            label="创建日期"
            width="150">
        </el-table-column>
        <el-table-column
            prop="startTime"
            label="开始日期"
            width="90">
        </el-table-column>
        <el-table-column
            prop="endTime"
            label="结束日期"
            width="90">
        </el-table-column>
        <el-table-column
            label="状态"
            width="150">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.enabled"
                @change="enabledChange(scope.row)"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                active-text="启用"
                inactive-text="禁用">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="200">
          <template slot-scope="scope">
            <el-button @click="showEdit(scope.row)">编辑</el-button>
            <el-button type="danger" @click="deleteAdvertising(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:10px;display: flex;justify-content: space-between">
        <el-pagination
            background
            @current-change="currentChange"
            @size-change="sizeChange"
            layout="sizes,prev, pager, next, jumper, ->, total"
            :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
        title="添加广告"
        :visible.sync="dialogVisible"
        @close="closeEdit"
        width="700px">
      <el-form ref="addAdvertisingForm" :model="advertising" :rules="addAdvertisingRules">
        <el-form-item label="标题" prop="title">
          <el-input style="width: 400px" v-model="advertising.title"
                    placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="曝光量" prop="odds">
          <div style="width: 300px;padding-left: 100px;">
<!--            <el-slider v-model="advertising.odds" :step="5"-->
<!--                       show-stops ></el-slider>-->
            <el-rate v-model="advertising.odds" :max="3"></el-rate>
          </div>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio v-model="advertising.type" label="广告" border size="medium" @change="radioChange(false)">广告</el-radio>
          <el-radio v-if="this.radioCheck===false" v-model="advertising.type" label="2" border size="medium" @change="radioChange(true)">其他</el-radio>
          <el-input v-if="this.radioCheck" style="width: 200px;" v-model="advertising.type"
                    placeholder="请输入类型"></el-input>
        </el-form-item>
        <el-form-item label="起始日期" prop="stringStartTime">
          <el-date-picker
              v-model="advertising.stringStartTime"
              type="date"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择起始日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" prop="stringEndTime">
          <el-date-picker
              v-model="advertising.stringEndTime"
              type="date"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态" prop="enabled">
          <el-switch
              style="padding-top: 20px;padding-bottom: 20px;"
              v-model="advertising.enabled"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
              active-text="启用"
              inactive-text="禁用">
          </el-switch>
        </el-form-item>
        <el-form-item label="形式">
          <el-radio v-model="advertising.toWeb" :label="0">站内链接</el-radio>
          <el-radio v-model="advertising.toWeb" :label="1">站外链接</el-radio>
        </el-form-item>
        <el-form-item prop="content" v-if="advertising.toWeb===0">
          <vue-tinymce
              v-model="advertising.content"
              :setting="setting"/>
        </el-form-item>
        <el-form-item prop="content" label="链接" v-if="advertising.toWeb===1">
          <el-input style="width: 400px"
              placeholder="请输入链接https或http开头"
              v-model="advertising.content"
              clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="封面图" prop="cover">
          <el-upload
              class="upload-demo"
              ref="upload"
              action="/api/advertising/web/save"
              accept=".jpg,.jpeg,.png"
              name="file"
              :data="advertising"
              :headers="headers"
              :before-upload="beforeAvatarUpload"
              :on-success="onSuccess"
              :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
<!--            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>-->
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5M,为更好展示效果，图片请使用大于1200x400(3:1)分辨率</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
         <el-button type="primary" @click="submitUpload">保 存</el-button>
  </span>
    </el-dialog>
    <el-dialog
        title="编辑广告"
        :visible.sync="editDialogVisible"
        @close="closeEdit"
        width="700px">
      <el-form ref="editAdvertisingForm" :model="advertising">
        <el-form-item label="标题" prop="title">
          <el-input style="width: 400px;"  v-model="advertising.title"
                    placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="曝光量">
          <div style="width: 300px;padding-left: 100px;">
<!--            <el-slider v-model="advertising.odds" :step="5"-->
<!--                       show-stops></el-slider>-->
            <el-rate v-model="advertising.odds" :max="3"></el-rate>
          </div>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-input style="width: 400px;" v-model="advertising.type"
                     placeholder="请输入类型"></el-input>
        </el-form-item>
        <el-form-item label="起始日期" prop="startTime">
          <el-date-picker
              v-model="advertising.startTime"
              type="date"
              :clearable="false"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择起始日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" prop="endTime">
          <el-date-picker
              v-model="advertising.endTime"
              type="date"
              :clearable="false"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="状态" prop="enabled">
          <el-switch
              style="padding-top: 20px;padding-bottom: 20px;"
              v-model="advertising.enabled"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="1"
              :inactive-value="0"
              active-text="启用"
              inactive-text="禁用">
          </el-switch>
        </el-form-item>
        <el-form-item v-if="advertising.toWeb===0" prop="content">
          <vue-tinymce
              v-model="advertising.content"
              :setting="setting"/>
        </el-form-item>
        <el-form-item prop="content" label="链接" v-if="advertising.toWeb===1">
          <el-input style="width: 400px"
                    placeholder="请输入链接https或http开头"
                    v-model="advertising.content"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="封面图" prop="cover">
          <el-image
              style="width: 200px; height: 60px"
              :src="serverUrl+advertising.cover"
              :fit="fit"></el-image>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="enabledChange(advertising)">保 存</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "AdvertisingList",
  data() {
    return {
      headers: {
        Authorization: window.sessionStorage.getItem('tokenStr')
      },
      advertisingList: [],
      serverUrl: this.GLOBAL.serverUrl,
      advertising: {
        title: '',
        cover: '',
        odds: 1,
        startTime: '',
        endTime: '',
        stringStartTime: '',
        stringEndTime: '',
        enabled: 1,
        toWeb:0
      },
      total: 0,
      currentPage: 1,
      size: 10,
      loading: false,
      dialogVisible: false,
      setting: {
        convert_urls: false,
        menubar: true,
        toolbar: "undo redo| preview | fullscreen | formatselect alignleft aligncenter alignright alignjustify | link unlink | numlist bullist | image media table | fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | removeformat | importword | kityformula-editor | hr | directionality | indent2em | lineheight ",
        toolbar_drawer: "sliding",
        quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
        plugins: "preview link image media table lists fullscreen quickbars code codesample importword imagetools kityformula-editor hr directionality indent2em lineheight",
        //  images_upload_url: '/editor/upload',
        //  images_upload_base_path: this.GLOBAL.serverUrl+'/',
        images_upload_credentials: true,
        language: 'zh_CN', //本地化设置
        height: 500,
        images_upload_handler: (blobInfo, succFun, failFun) => {
          var serverUrl = this.GLOBAL.serverUrl
          var xhr, formData;
          var file = blobInfo.blob();//转化为易于理解的file对象
          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open('POST', '/api/editor/upload'); //this.GLOBAL.serverUrl+
          xhr.setRequestHeader('Authorization', window.sessionStorage.getItem('tokenStr'))
          xhr.onload = function () {
            var json;
            if (xhr.status != 200) {
              failFun('HTTP Error: ' + xhr.status);
              return;
            }
            json = JSON.parse(xhr.responseText);
            if (!json || typeof json.location != 'string') {
              failFun('Invalid JSON: ' + xhr.responseText);
              return;
            }
            var path = serverUrl + json.location
            //var path =  json.location
            succFun(path);
          };
          // this.uploadPostRequest('/editor/upload',file).then(resp=>{
          //   if(resp){
          //     succFun(resp.location)
          //   }
          // })
          formData = new FormData();
          formData.append('file', file, file.name);//此处与源文档不一样
          xhr.send(formData);
        }
      },
      addAdvertisingRules: {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: blur
        }],
        odds: [{
          required: true,
          message: '请输入曝光量',
          trigger: blur
        }],
        stringStartTime: [{
          required: true,
          message: '请选择起始日期',
          trigger: blur
        }],
        stringEndTime: [{
          required: true,
          message: '请选择结束日期',
          trigger: blur
        }],
        type: [{
          required: true,
          message: '请选择或输入类型',
          trigger: blur
        }],
        content: [{
          required: true,
          message: '请输入广告内容',
          trigger: blur
        }]
      },
      editAdvertising: null,
      editDialogVisible: false,
      radioCheck:false
    }
  },
  mounted() {
    this.initAdvertisingList()
  }
  ,
  methods: {
    initAdvertisingList() {
      this.loading = true
      this.getRequest('/advertising/web/list?currentPage=' + this.currentPage + '&size=' + this.size).then(resp => {
        this.loading = false
        if (resp) {
          this.advertisingList = resp.data
          this.total = resp.total
        }
      })
    }
    ,
    sizeChange(size) {
      this.size = size
      this.initAdvertisingList()
    }
    ,
    currentChange(currentPage) {
      this.currentPage = currentPage
      this.initAdvertisingList()
    }
    ,
    deleteAdvertising(advertising) {
      this.$confirm('此操作将永久删除【' + advertising.title + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRequest('/advertising/web/' + advertising.id).then(resp => {
          if (resp) {
            this.initAdvertisingList()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    enabledChange(advertising) {
      this.putRequest('/advertising/web/', advertising).then(resp => {
        if (resp) {
          this.initAdvertisingList()
        }
      })
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isLt5M) {
        this.$message.error('上传轮播图片大小不能超过 5MB!')
      }
      return isLt5M
    },
    onSuccess() {
      this.advertising = {
        title: '',
        cover: '',
        odds: 1,
        stringStartTime: '',
        stringEndTime: '',
        enabled: 1
      }
      this.$refs.upload.clearFiles()
      this.dialogVisible = false
      this.initAdvertisingList()
    },
    submitUpload() {
      this.$refs['addAdvertisingForm'].validate(valid => {
        if (valid) {
          this.$refs.upload.submit()
        } else {
          this.$message('标*字段不能为空')
        }
      })
    },
    showEdit(editAdvertising) {
      this.advertising = editAdvertising
      this.editDialogVisible = true
    },
    closeEdit() {
      this.advertising = {
        title: '',
        cover: '',
        odds: 1,
        stringStartTime: '',
        stringEndTime: '',
        enabled: 1
      }
    },
    radioChange(flag){
      this.radioCheck = flag
      if(flag){
        this.advertising.type=''
      }
    }
  }
}
</script>

<style scoped>

</style>
